import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { NavigationStart, Router, Event } from '@angular/router';
import { NotificationsService } from './core/services/notifications.service';
import { AngularSignalRService } from './core/services/angular-signalr.service';
import { EventService } from './core/services/event.service';
import { PortalSettingsService } from './core/services/portal-settings.service';
import { Subscription } from 'rxjs';
import { UtilityService } from './core/services/utility.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'HRIM';
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private notificationsService: NotificationsService,
    private angularSignalRService: AngularSignalRService,
    private eventService: EventService,
    private portalSettingsService: PortalSettingsService,
    private utilityService: UtilityService,
    @Inject('Window') private window: Window
  ) {}

  ngOnInit(): void {
    this.initializeRouterEventsSubscription();
    this.angularSignalRService.establishHub('AngularSignalRHub');
    this.subscriptions.push(this.eventService.onSendLogoutSignalReceived(() => this.signalRLogout()));
    this.subscriptions.push(
      this.eventService.onSendPortalSettingsUpdateReceived(() => this.portalSettingsService.setPortalSettingsAreStale())
    );
  }

  ngOnDestroy(): void {
    // Stop SignalR connection to prevent multiple connections
    this.subscriptions.forEach(sub => sub?.unsubscribe());
    this.angularSignalRService.stopConnection();
  }

  public signalRLogout(): void {
    sessionStorage.clear();
    if (!this.utilityService.isLoggedOut) {
      const url = this.getLogoutUrl(this.window.location.href);
      this.navigate(url);
    }
  }

  private getLogoutUrl(href: string): string {
    return '/Account/Logout?signalRLogout=true';
  }

  private navigate(url: string): void {
    this.window.location.href = url;
  }

  private initializeRouterEventsSubscription(): void {
    this.router.events.subscribe((event: Event) => this.executeEventCallbacks(event));
  }

  private executeEventCallbacks(event: Event) {
    if (event instanceof NavigationStart) {
      this.notificationsService.clearNotifications();
    }
  }
}
